<template>
  <div class="opreate-record">
    <div class="breadcrumb-box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>系统管理</el-breadcrumb-item>
        <el-breadcrumb-item>操作记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="header-box">
      <div class="header-line">
        <span class="header-label">日期</span>
        <el-date-picker v-model="date" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" size="small" style="width: 230px"> </el-date-picker>
        <span class="header-label">操作类型</span>
        <el-select v-model="opreateType" size="small">
          <el-option label="全部" value=""> </el-option>
          <el-option label="新增采购记录" :value="1"> </el-option>
          <el-option label="编辑采购记录" :value="2"> </el-option>
          <el-option label="删除采购记录" :value="3"> </el-option>
        </el-select>
        <span class="header-label">业务ID</span>
        <el-input placeholder="请输入SKU" size="small" clearable v-model="bussinessId"> </el-input>
        <span class="header-label">操作人</span>
        <el-select v-model="loginPhone" size="small" filterable clearable placeholder="全部">
          <el-option v-for="user in operateUserOptions" :key="user.id" :label="user.name" :value="user.loginPhone"></el-option>
        </el-select>
        <span class="header-label">产品类型</span>
        <el-select placeholder="产品类型" size="small" v-model="productType" filterable>
          <el-option label="全部" value=""></el-option>
          <el-option v-for="product in productList" :key="product.type" :label="product.productName" :value="product.productType"></el-option>
        </el-select>
        <span class="header-label">产品颜色</span>
        <el-select placeholder="产品类型" size="small" v-model="productColor" filterable>
          <el-option label="全部" value=""></el-option>
          <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key"></el-option>
        </el-select>
        <span class="header-label">机型</span>
        <el-select placeholder="机型" size="small" v-model="productModel">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="model in modelList" :key="model" :label="model" :value="model"></el-option>
        </el-select>
        <span class="header-label">SKU</span>
        <el-input placeholder="请输入SKU" size="small" clearable v-model="sku"> </el-input>
        <el-button type="primary" size="small" v-on:click="onQueryBtnClick">查询</el-button>
      </div>
    </div>
    <div class="main-box">
      <el-table :data="operateHistory" border style="width: 100%" :height="screenHeight" cell-class-name="table-cell" row-class-name="table-row" header-cell-class-name="table-header-cell">
        <el-table-column label="序号" width="50px">
          <template slot-scope="scope">
            {{ beginIndex + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="opreateUserName" label="操作人" width="70px"> </el-table-column>
        <el-table-column prop="opreateTimeLabel" label="操作时间" width="180px"> </el-table-column>
        <el-table-column prop="opreateTypeLabel" label="操作类型" width="150px"> </el-table-column>
        <el-table-column prop="bussinessId" label="业务ID" width="150px"> </el-table-column>
        <el-table-column prop="content" label="操作详情"> </el-table-column>
      </el-table>

      <el-pagination ref="pageNav" layout="prev,pager, next" background prev-text="上一页" next-text="下一页" :page-count="pageCount" :page-size="pageSize" :total="total" @prev-click="prevBtnClick" @next-click="nextBtnClick" @current-change="curBtnClick"> </el-pagination>
    </div>
  </div>
</template>

<script>
import { requestModules, systemModules } from "@r";
import { activeProducts, allActiveProducts, colors, models } from "../../utils/constant.js";
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      loginPhone: "",
      operateUserOptions: [],
      date: [new Date(new Date().getTime() - 24 * 3600 * 1000 * 7), new Date(new Date().getTime() + 86400000)],
      operateHistory: [],
      beginIndex: 0,
      pageSize: 200,
      totalPage: 1,
      currentPage: 1,
      total: 0,
      pageCount: 1,
      opreateType: "",
      bussinessId: "",
      screenHeight: document.body.clientHeight - 64 - 132 - 68 - 35,
      productList: localStorage.getItem("shopType") == 6 ? allActiveProducts : activeProducts,
      colorList: colors,
      modelList: models,
      productType: "",
      productColor: "",
      sku: "",
      productModel: "",
      model: "",
    };
  },
  components: {},
  watch: {
    productModel: {
      handler: function (newValue, oldValue) {
        let blankReg = new RegExp(" ", "igm");
        let productModel = newValue.replace(blankReg, "");
        this.model = productModel;
      },
    },
  },
  created() {},
  activated() {
    this.loadOperateUsers();
    this.operationHistory();
  },
  mounted() {
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 132 - 68 - 35;
    },
    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      // let lastEmittedPage = pageNav.lastEmittedPage;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.beginIndex = (internalCurrentPage - 1) * this.pageSize;
      this.operationHistory();
    },
    onQueryBtnClick() {
      this.beginIndex = 0;
      this.operationHistory();
    },
    loadOperateUsers() {
      systemModules
        .listUsers()
        .then(res => {
          const users = Array.isArray(res.data) ? res.data : [];
          const seen = new Set();
          this.operateUserOptions = users
            .map(user => {
              const loginPhone = String((user && user.username) || "").trim();
              const name = String((user && (user.nickname || user.username)) || "").trim();
              return {
                id: user && user.id != null ? user.id : loginPhone,
                name: name || loginPhone,
                loginPhone,
              };
            })
            .filter(user => {
              if (!user.loginPhone || seen.has(user.loginPhone)) {
                return false;
              }
              seen.add(user.loginPhone);
              return true;
            })
            .sort((a, b) => a.name.localeCompare(b.name, "zh"));
        })
        .catch(() => {
          this.operateUserOptions = [];
        });
    },
    operationHistory() {
      let startTime = 0;
      let endTime = new Date().getTime();
      if (this.date && this.date.length > 1) {
        startTime = new Date(this.date[0].format("yyyy-MM-dd") + " 00:00:00").getTime();
        endTime = new Date(this.date[1].format("yyyy-MM-dd") + " 23:59:59").getTime();
      }

      requestModules
        .fetchOpreateLogs({
          startTime: startTime,
          endTime: endTime,
          loginPhone: this.loginPhone || "",
          opreateType: this.opreateType,
          bussinessId: this.bussinessId,
          beginIndex: this.beginIndex,
          pageSize: this.pageSize,
          productType: this.productType,
          productColor: this.productColor,
          sku: this.sku,
          model: this.model,
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "获取操作记录失败",
            });
            return;
          }

          this.operateHistory = res.ldata;
          this.total = res.total;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "未知错误",
          });
        });
    },
  },
};
</script>

<style lang="scss">
.opreate-record {
  .header-box {
    .el-button {
      width: auto;
    }

    padding: 20px;
  }
  .breadcrumb-box {
    .el-breadcrumb {
      margin: 20px 0px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .main-box {
    background-color: white;
    padding: 0 20px;
  }
}
</style>
